import React from "react";

import "./index.scss";



const MainRadioButton = ({
  checked,
  onClick,
  label,
  className
}) => {

  const detectTheme = () => {
    return JSON.parse(localStorage.getItem("theme_config")) ? JSON.parse(localStorage.getItem("theme_config")).theme : "light"
  }

  return (
    <label className={`custom-radio-container  ${className} ${detectTheme()}`}>
      <input
        type="radio"
        checked={checked}
        onChange={() => { }}
        onClick={onClick}
        className="custom-radio-input"
      />
      <span className="custom-radio"></span>
      {label}
    </label>
  );
};

export default MainRadioButton;
